import { CSSProperties, useMemo } from "react";
import { useToasts } from "./useToasts";

/**
 * Hook for calculating position styles for the show more button
 * @returns CSS properties for positioning the show more button
 */
export const useShowMoreButtonPositionStyles = (): CSSProperties => {
  const { toasts, toastHeights, toastsBeforeStack } = useToasts();
  const totalToasts = toasts.length;
  const extraSpace = totalToasts > toastsBeforeStack + 1 ? "2rem" : "1rem";
  const top = useMemo(() => {
    if (totalToasts > toastsBeforeStack) {
      // Build a height lookup map by toast ID for correct matching
      const heightMap = new Map(toastHeights.map((t) => [t.id, t.height]));

      // Use the toasts array to get the visible (non-stacked) toasts' heights
      return toasts
        .slice(-toastsBeforeStack)
        .map((t) => heightMap.get(t.id))
        .filter((h): h is number => h !== undefined)
        .reduce((t, c) => t + c, 0);
    }
    return "unset";
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toasts, toastHeights, toastsBeforeStack]);

  return {
    // -0.75px fixes hover issue when 1rem != 16px due to pixel rounding
    top: `calc(${top}px + ${extraSpace} - 0.75px)`,
    position: "absolute",
    display: totalToasts > toastsBeforeStack ? undefined : "none",
    transition: "top var(--toast-animation-duration) ease-in",
  };
};
